import React from "react";
import { useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "./Dashboard.css";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { FaSearchDollar } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux/es/exports";
import axiosinstances from "../../Helper/useAxios";
import { v4 as uuid4 } from "uuid";
import {
  dangerColor,
  formatNumberForIndia,
  requestLoading,
  utrLeng,
} from "../../utils/comman/Common";
import {
  REQID,
  TXNID,
  setpageContent,
  UTR,
  VPA,
  ODRCODE,
  Statusoptions,
  searchbyOptions,
  checkTxnIsnotFake,
} from "../../utils/Constant";

import { ShowAllDetails } from "../Model/ShowAllDetails";
import { Tooltip } from "react-tooltip";
import moment from "moment";
import moments from "moment-timezone";
import AddTicket from "../Model/AddTicket";
import UILoader from "../../utils/comman/loader";
import MidSectionUI from "./MidSectionUI";

import StatusDetails from "../../utils/comman/statusDetails";
import AddAmount from "../Model/AddAmount";
import { getBalance } from "../../redux/Getbalance/action";
import { appVersion } from "../../version";

const FIRST_PAGE = 0;
const MerchantWallet = () => {
  const profileInfo = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );

  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // const userTimeZone = 'Asia/Dubai'
  const accessPath = process.env.REACT_APP_accessPath;
  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const e = JSON.parse(sessionStorage.getItem("token"));
  console.log("mid1", mid);
  const INTIAL_VALUE = {
    merchantId: "",
    type: "PAY_IN",
    txnId: "",
    createdBy: id,
    description: "",
    userUtr: "",
    userTxnDate: "",
    comments: null,
    attachmentId: "",
  };
  const dispatch = useDispatch();
  const balance = useSelector(
    (state) => state?.getbalanceresucer?.getbalancelist
  );
  const roles = useSelector((state) => state.authReducer?.auth?.roles);
  const [ticketRequest, setticketRequest] = useState(INTIAL_VALUE);
  const [selectedTraxn, setSelectedTraxn] = useState(null);
  const [show, setShow] = useState(false);
  const [showAddAmount, setShowAddAmount] = useState(false);
  const [ticketLists, setTicketLists] = useState(null);
  const [showTicketDropdown, setShowTicketDropdown] = useState(false);
  const [selectedTicket, setselectedTicket] = useState();
  const [isAllTicketResolved, setIsAllTicketResolved] = useState(true);
  const [statusOption, setStatusOption] = useState(Statusoptions);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [formDate, setFormDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [selectedDataToShow, setSelectedDataToShow] = useState({});
  const [showModalDetails, setShowModelDetails] = useState(false);
  const [showModal, setShowModel] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [statusDate, setStatusDate] = useState(today);
  const [isStatusFilter, setIsStatusFilter] = useState(false);
  const [isCalledSatausApi, setIsCalledSatausApi] = useState(false);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [searched, setSearched] = useState({
    name: "",
    typing: false,
    typingTimeout: 0,
  });

  const usersearchs = {
    txnid: null,
    reqid: null,
    orderCode: null,
    utr: null,
    vpa: null,
  };
  const [filterupdatedOn, setFilterupdatedOn] = useState(false);
  const [table, settable] = useState([]);
  const [backupTableData, setBackupTableData] = useState([]);
  const [merchantLits, setMerchantList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [balanceLoader, setBalanceLoader] = useState(false);
  // const [balance, setBalance] = useState();
  console.log("merchantLits", merchantLits);
  console.log("accountList", accountList);
  const [transactionStatuswithAmount, setTransactionStatuswithAmount] =
    useState([
      {
        id: "SUCCESS",
        count: 0,
        total: 0,
      },
      {
        id: "PENDING",
        count: 0,
        total: 0,
      },
      {
        id: "FAILED",
        count: 0,
        total: 0,
      },
    ]);
  console.log("table", table);
  const [searchedBy, setSearchedBy] = useState();
  const [searchedByItem, setSearchedByItem] = useState(searchbyOptions);
  const [searchedByItemShow, setSearchedByItemShow] = useState(true);
  const [userSearchBy, setUserSearchBy] = useState(usersearchs);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const storeData = useSelector(
    (state) => state?.configDetailsreducer?.details
  );

  const [warningShown, setWarningShown] = useState(false);
  const currentVersionfromApi =
    (Array.isArray(storeData) &&
      storeData.filter(
        (val) => val.id == "REACT_APP_QRBONPAY_MER_PORTAL_CUREENT_VERSION"
      )) ||
    [];
  useEffect(() => {
    if (
      appVersion &&
      Array.isArray(currentVersionfromApi) &&
      currentVersionfromApi.length > 0
    ) {
      const apiCurrentVersion = currentVersionfromApi[0]?.value;
      if (apiCurrentVersion !== appVersion && !warningShown) {
        toast.warn(
          `Kindly reload your application, a new version ${apiCurrentVersion} is available.`
        );
        setWarningShown(true); // Set the flag to prevent further warnings
      }
    }
  }, [currentVersionfromApi, appVersion, warningShown]);
  const toggleDropdown = (e) => {
    console.log("Filter toggle clicked");
    e.stopPropagation();
    setIsDropdownOpen((prevState) => !prevState);
  };
  console.log("dropdownOpen", dropdownOpen);
  const increaseOneDate = (date) => {
    // console.log('datedate', date)
    if (date !== undefined && date !== null && date !== "") {
      return moment(date).add(1, "day").format("YYYY-MM-DD");
    } else {
      return null;
    }
    // const nextdate = (date !== undefined  && date !== null && date !== '')  ? moment(date).add(1, 'day').format('YYYY-MM-DD') : null
    //  return nextdate;
  };
  const addTimeTodate = (date) => {
    const nextDay = moment(date).add(1, "day").format("YYYY-MM-DD");
    return `${nextDay}T00:00:00`;
  };
  const addTimeFromdate = (date) => {
    return `${date}T00:00:00`;
  };
  const finalStatus =
    Array.isArray(selectedStatus) && selectedStatus.length > 0
      ? selectedStatus.map((item) => item.value)
      : [];
  const url = `${process.env.REACT_APP_WALLET_HISTORY}${mid}/${statusDate}/${
    paginationDetails.currentPage - 1
  }`;
  var request = {
    mid: mid !== null && mid !== undefined ? mid : "",
    requestId: userSearchBy.reqid,
    orderCode: userSearchBy.orderCode,
    txnId: userSearchBy.txnid,
    utr: userSearchBy.utr,
    vpa: userSearchBy.vpa,
    useUpdatedOn: filterupdatedOn,
    fromDate: formDate,
    toDate: toDate,
    statusList: finalStatus,
    pageNum: 0,
    perPage: paginationDetails.postsPerPage,
  };

  const getUniqId = () => {
    const uuid = uuid4();
    const uuidWithoutDashes = uuid.replace(/-/g, "").toUpperCase();
    return uuidWithoutDashes;
  };

  useEffect(() => {
    setSearchedByItemShow(true);
    setSearchedBy();
  }, [search]);
  useEffect(() => {
    setDropdownOpen(false);
  }, []);

  useEffect(() => {
    if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
      const values = selectedStatus.map((val) => val.value);
      setFinalSelectedStatus(values);
    } else if (Array.isArray(selectedStatus) && selectedStatus.length === 0) {
      setFinalSelectedStatus([]);
    }
  }, [selectedStatus]);
  // console.log('first', paginationDetails)
  const handalpageclick = async (index) => {
    if (url) {
      callApis(index - 1);
      setPaginationDetails((prev) => {
        return { ...prev, currentPage: index };
      });
    }
  };

  // const fetchAccountLists = async () => {
  //   // setDataLoading(true);

  //   let url = `/api/v1/upi/account/list?bank=*`;

  //   const response = await axiosInstance
  //     .get(url, {
  //       headers,
  //     })
  //     .then((res) => {
  //       //  return res
  //       console.log("response", res);
  //       setAccountList(res.data);
  //     })
  //     .catch((err) => {
  //       //console.log(err);

  //       toast.error("Something went wrong");
  //     });
  //   if (response) {
  //     const result = response.data.orders;

  //     if (result) {
  //     }

  //     return response.data;
  //   }
  //   setDataLoading(false);
  //   return false;
  // };
  // useEffect(() => {

  //   fetchAccountLists();
  // }, []);
  const searchdata = (event) => {
    if (searched.typingTimeout) {
      clearTimeout(searched.typingTimeout);
    }
    if (!searched.typing) {
      // setRetailerList([])
    }

    if (event.target.value !== "") {
      const trimSearch = event.target.value.trim();
      setSearched({
        name: trimSearch,
        typing: true,
        typingTimeout: setTimeout(function () {
          // sendToParent(searched.name);
          if (event.target.value) {
            setSearchTyping(true);
            setsearch(trimSearch);
          } else {
          }
        }, 500),
      });
    } else {
      setsearch(event.target.value);
      setSearched({
        typing: false,
      });
    }
  };
  const reloadTxn = () => {
    callApis(0);
  };

  // useEffect(() => {
  //   const finalStatus = selectedStatus.map((item) => item.value);
  //   const url =`${process.env.REACT_APP_WALLET_HISTORY}${mid}/${statusDate}/${paginationDetails.currentPage - 1}`

  //   request["fromDate"] = formDate;
  //   request["toDate"] = increaseOneDate(toDate);
  //   request["statusList"] = finalStatus;
  //   request["pageNum"] = paginationDetails.currentPage - 1;
  //   request["perPage"] = paginationDetails.postsPerPage;
  //   if (url && request) {
  //     callApis(request);
  //   }
  // }, [mid]);
  // useEffect(() => {
  //   const finalStatus = selectedStatus.map((item) => item.value);
  //   const url = process.env.REACT_APP_WALLET_HISTORY;

  //   request["fromDate"] = statusDate ;
  //   request["toDate"] = increaseOneDate(statusDate) ;
  //   request["statusList"] = finalStatus;
  //   request["pageNum"] = paginationDetails.currentPage - 1;
  //   request["perPage"] = paginationDetails.postsPerPage;
  //   if (url && request && Array.isArray(selectedStatus) && selectedStatus.length > 0) {
  //
  //     callApis(url, request);
  //   }
  // }, [selectedStatus]);

  useEffect(() => {
    if (statusDate) {
      callApis(paginationDetails.currentPage - 1);
    }
  }, [statusDate]);

  async function callApis(page) {
    if (mid == undefined || mid === null || mid == "") {
      return;
    }
    await fetchpagedata(page);
  }
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  const fetchpagedata = async (page) => {
    const url = `${process.env.REACT_APP_WALLET_HISTORY}${mid}/${statusDate}/${page}`;
    setDataLoading(true);
    const response = await axiosInstance
      .get(url, { headers })
      .then((res) => {
        if (res?.data?.empty !== undefined && !res?.data?.empty) {
          setDataLoading(false);
          settable([]);
          return;
        }

        if (res?.data?.error !== undefined) {
          setDataLoading(false);
          settable([]);
          return;
        }

        settable(res.data.transactions);
        setBackupTableData(res.data);
        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            currentPage: res.data?.pageNum + 1,
            totalPost: res.data?.total,
            totalPages: res.data?.pages,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        setDataLoading(false);
        setIsDataLoaded(false);
        toast.error("Something went wrong");
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  useEffect(() => {
    if (search.length > 2) {
      callApis(paginationDetails.currentPage - 1);
    }
  }, [userSearchBy]);
  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    setDropdownOpen(false);

    if (url && request) {
      callApis(paginationDetails.currentPage - 1);
    }
  };
  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    const formattedTime = currentDate
      .toTimeString()
      .slice(0, 8)
      .replace(/:/g, "");
    return `${formattedDate}_${formattedTime}`;
  };
  const convertToXLSX = (data, fileName) => {
    const parsedData = Papa.parse(data, { header: true });
    const worksheet = XLSX.utils.json_to_sheet(parsedData.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };
  const onExportData = async (e) => {
    e.preventDefault();

    if (mid == undefined || mid == null || mid == "") {
      return;
    }

    const fetchExportdata = async (url) => {
      setDataLoading(true);
      const response = await axiosInstance
        .get(url, { headers })
        .then((res) => {
          if (res?.data?.empty !== undefined && !res?.data?.empty) {
            setDataLoading(false);

            return;
          }
          setDataLoading(false);
          setIsDataLoaded(false);
          const fileName = `${getUniqId()}_${getCurrentDateTime()}`;
          convertToXLSX(res?.data, fileName);
        })
        .catch((err) => {
          console.log(err);
          setDataLoading(false);
          setIsDataLoaded(false);
          toast.error("Something went wrong");
        });

      if (response) {
        return response.data;
      }
      setDataLoading(false);
      setIsDataLoaded(false);
      return false;
    };
    const url = `/api/v1/upi/merchant/wallet/report/${mid}/${formDate}/${toDate}`;

    if (url) {
      const fileExport = await fetchExportdata(url);
      setIsDropdownOpen(!isDropdownOpen);
    }
  };
  const callStatus = async (values) => {
    callApis(paginationDetails.currentPage - 1);
  };
  const fetchBalance = async () => {
    const data = { id: mid, headers: headers };
    dispatch(getBalance(data));
  };

  const resetApply = () => {
    setFinalSelectedStatus([]);
    setSelectedStatus([]);
    setIsExportable(false);
    setDropdownOpen(false);
    setFormDate("");
    setToDate("");
    // setFilterupdatedOn(false)
    const request = {
      mid: mid !== null && mid !== undefined ? mid : "",
      requestId: null,
      orderCode: null,
      txnId: null,
      utr: null,
      vpa: null,
      fromDate: null,
      toDate: null,
      // useUpdatedOn: false,
      statusList: [],
      pageNum: FIRST_PAGE,
      perPage: paginationDetails.postsPerPage,
    };

    if (url) {
      callApis(paginationDetails.currentPage - 1);
      setIsDropdownOpen(!isDropdownOpen);
    }
  };
  const fromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const toDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const changeHandler = (select) => {
    setSelectedStatus(select);
  };
  const showBal = (balance) => {
    if (
      balance?.balance !== undefined &&
      balance?.balance >= 0 &&
      !balanceLoader
    ) {
      return <>{formatNumberForIndia(balance?.balance)}</>;
    } else if (balance?.balance < 0 && !balanceLoader) {
      return <span style={{ color: dangerColor }}>{"NA"}</span>;
    } else if (balance?.errCode !== undefined && !balanceLoader) {
      return <span style={{ color: dangerColor }}>{"NA"}</span>;
    } else {
      return <FaSearchDollar size={15} />;
    }
  };
  const payInType = "payin";
  const payoutType = "payout";
  const showTotalWalletBalance = (type) => {
    return (
      Array.isArray(balance) &&
      balance.map((balance, index) => {
        if (balance.type == type) {
          return showBal(balance);
        }
      })
    );
  };
  const checkDisable = () => {
    let disabled = true;
    if (finalSelectedStatus !== undefined && finalSelectedStatus.length > 0) {
      disabled = false;
    } else if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    }
    return disabled;
  };
  const handleClose = () => {
    setShow(false);
    setTicketLists(null);
    setticketRequest(INTIAL_VALUE);
    setShowTicketDropdown(false);
    setselectedTicket();
    setIsAllTicketResolved(true);
  };
  //setIsAllTicketResolved
  const handleShow = () => {
    setShow(true);
    setTicketLists(null);
    setticketRequest(INTIAL_VALUE);
    setShowTicketDropdown(false);
    setselectedTicket();
    setIsAllTicketResolved(true);
  };

  //editPlans
  const clearSearchData = () => {
    setUserSearchBy((pre) => ({
      ...pre,
      txnid: null,
      reqid: null,
      orderCode: null,
      utr: null,
      vpa: null,
    }));
    setsearch("");
    setSearchedBy();

    setSearched({ name: "", typing: false, typingTimeout: 0 });
    resetApply();
    setDataLoading(false);
    setIsDataLoaded(true);

    setPaginationDetails((prev) => {
      return {
        ...prev,
        totalPost:
          backupTableData?.totalElements !== undefined &&
          backupTableData?.totalElements,
        totalPages:
          backupTableData?.totalPages !== undefined &&
          backupTableData?.totalPages,
        currentPage:
          backupTableData?.currentPage !== undefined
            ? backupTableData?.currentPage + 1
            : 1,
      };
    });
    // const request = {
    //   mid: mid !== null && mid !== undefined ? mid : '',
    //   requestId: null,
    //   orderCode: null,
    //   txnId: null,
    //   utr: null,
    //   vpa: null,
    //   fromDate: null ,
    //   toDate: null ,
    //   statusList: [],
    //   pageNum: 0,
    //   perPage: paginationDetails.postsPerPage,
    // };
    // if (url && request) {
    //   callApis(url, request);
    // }
  };
  const selectedTranxtForIssue = (e, data) => {
    e.preventDefault();
    setticketRequest((pre) => ({
      ...pre,
      userUtr: data?.userEnteredUtr !== undefined ? data?.userEnteredUtr : "",
    }));
    setSelectedTraxn(data);
    handleShow();
  };

  const initialValue = 0;
  const sumOfallSatus = transactionStatuswithAmount.reduce(
    (accumulator, currentValue) => accumulator + (currentValue?.count || 0),
    initialValue
  );

  function validateUTR(utr) {
    // Check if UTR is exactly 12 digits
    if (!/^\d{12}$/.test(utr)) {
      return false;
    }

    // Get the last digit of the current year
    const currentYearLastDigit = new Date().getFullYear().toString().slice(-1);

    // Get the last two digits of the previous year
    const previousYearLastTwoDigits = (new Date().getFullYear() - 1)
      .toString()
      .slice(-2);

    // Get the current month and day
    const currentMonth = new Date().getMonth() + 1; // Add 1 to get the month number (January is 1, December is 12)
    const currentDay = new Date().getDate();

    // Check if today is January 1st and the UTR corresponds to December 31st of the previous year
    if (currentMonth === 1 && currentDay === 1) {
      // customLog("utr", utr);
      // customLog(utr[0], previousYearLastTwoDigits[1]);
      if (utr[0] === previousYearLastTwoDigits[1]) {
        return true;
      }
    }

    // Check if the first digit of the UTR matches the last digit of the current year
    if (utr[0] !== currentYearLastDigit) {
      return false;
    }

    return true;
  }

  const showAllData = (data) => {
    setSelectedDataToShow({ ...data });
    setShowModelDetails(true);
    setShowModel(true);
  };
  const closeModal = () => {
    setShowModel(false);
  };
  const showMerchnat = (mid, name) => {
    if (merchantLits !== null && merchantLits !== undefined) {
      const lists = merchantLits.filter((val) => val.id == mid);
      if (lists.length > 0) {
        const values = lists[0]?.name.substring(0, 14);
        return name == "fullname" ? lists[0]?.name : values;
      } else {
        return "NA";
      }
    } else {
      return "NA";
    }
  };

  // const bgColor = search.length > 3 ? "#FEC7B4" : "#848587";
  const bgColor = "#848587";
  const setStatusDateHandler = (val) => {
    setSelectedStatus([]);
    setStatusDate(val);
    setFormDate(val);
    setToDate(increaseOneDate(val));
    setIsCalledSatausApi(true);
    setIsStatusFilter(true);
  };
  function calculateTimeDifference(startTime, endTime, userTimeZone) {
    const currentUserTime = moments().tz(userTimeZone);
    const startMoment = moments(startTime).tz(userTimeZone); // Assuming startTime and endTime are already in the user's time zone
    const endMoment = moments(endTime).tz(userTimeZone);
    const timeDifference = endMoment.diff(startMoment);
    const duration = moments.duration(timeDifference);

    // Format the duration
    // const daysPart = duration.days() > 0 ? `${duration.days()}D, ` : '';
    // const formattedDuration = `${daysPart}${duration.hours()}:${duration.minutes()}:${duration.seconds()}`;
    const daysPart = duration.days() > 0 ? `${duration.days()}D, ` : "";
    const hours =
      duration.hours() < 10 ? `0${duration.hours()}` : duration.hours();
    const minutes =
      duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes();
    const seconds =
      duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();
    const formattedDuration = `${daysPart}${hours}:${minutes}:${seconds}`;

    return formattedDuration;
  }
  function getTodaytDateTime() {
    return moment().format("YYYY-MM-DD HH:mm:ss");
  }
  const handleCloseShowAmount = () => {
    setShowAddAmount(false);
  };
  const handleOpenShowAmount = () => {
    setShowAddAmount(true);
  };
  return (
    <React.Fragment>
      {loading ? (
        requestLoading()
      ) : (
        <>
          <Tooltip id="txn-tooltip" place="right" effect="solid" />
          <Tooltip id="txn-tooltip-vpa" place="bottom" effect="solid" />

          {/* <Tooltip id="txn-tooltip-bottom" place="right" effect="solid" /> */}
          <ShowAllDetails
            showModal={showModal}
            closeModal={closeModal}
            data={selectedDataToShow}
            modalWidth={undefined}
          />
          <AddAmount
            show={showAddAmount}
            handleClose={handleCloseShowAmount}
            headers={headers}
            mid={mid}
            fetchBalance={fetchBalance}
          />
          <MidSectionUI
            applyStatus={onExportData}
            statusOption={statusOption}
            changeHandler={changeHandler}
            selectedStatus={selectedStatus}
            filterupdatedOn={filterupdatedOn}
            setFilterupdatedOn={setFilterupdatedOn}
            fromDateHandler={fromDateHandler}
            formDate={formDate}
            toDateHandler={toDateHandler}
            toDate={toDate}
            checkDisable={checkDisable}
            resetApply={resetApply}
            searched={searched}
            searchdata={searchdata}
            bgColor={bgColor}
            search={search}
            searchedByItemShow={searchedByItemShow}
            searchedBy={searchedBy}
            AddTicket={AddTicket}
            ticketRequest={ticketRequest}
            show={show}
            handleClose={handleClose}
            handleShow={handleShow}
            showTicketDropdown={showTicketDropdown}
            selectedTicket={selectedTicket}
            setselectedTicket={setselectedTicket}
            isAllTicketResolved={isAllTicketResolved}
            setIsAllTicketResolved={setIsAllTicketResolved}
            ticketLists={ticketLists}
            headers={headers}
            StatusDetails={StatusDetails}
            transactionStatuswithAmount={transactionStatuswithAmount}
            isDataLoaded={isDataLoaded}
            calculateTimeDifference={calculateTimeDifference}
            getTodaytDateTime={getTodaytDateTime}
            userTimeZone={userTimeZone}
            showMerchnat={showMerchnat}
            checkTxnIsnotFake={checkTxnIsnotFake}
            utrLeng={utrLeng}
            setSearchTyping={setSearchTyping}
            searchedByItem={searchedByItem}
            setSearchedBy={setSearchedBy}
            setSearchedByItemShow={setSearchedByItemShow}
            selectedTraxn={selectedTraxn}
            setShowTicketDropdown={setShowTicketDropdown}
            setTicketLists={setTicketLists}
            sumOfallSatus={sumOfallSatus}
            setStatusDateHandler={setStatusDateHandler}
            statusDate={statusDate}
            reloadTxn={reloadTxn}
            dataLoading={dataLoading}
            UILoader={UILoader}
            table={table}
            REQID={REQID}
            TXNID={TXNID}
            UTR={UTR}
            ODRCODE={ODRCODE}
            selectedTranxtForIssue={selectedTranxtForIssue}
            showAllData={showAllData}
            searchTyping={searchTyping}
            paginationDetails={paginationDetails}
            onExportData={onExportData}
            isExportable={isExportable}
            setpageContent={setpageContent}
            handalpageclick={handalpageclick}
            dropdownOpen={dropdownOpen}
            setDropdownOpen={setDropdownOpen}
            handleOpenShowAmount={handleOpenShowAmount}
            showTotalWalletBalance={showTotalWalletBalance}
            isDropdownOpen={isDropdownOpen}
            toggleDropdown={toggleDropdown}
          />
        </>
      )}
    </React.Fragment>
  );
};

export default MerchantWallet;
